import type { PedagogyDestination } from "./types";

export function navigate(path: string): void {
  if (window.location.pathname === path) return;
  window.history.pushState({}, "", path);
  window.dispatchEvent(new PopStateEvent("popstate"));
}

export function destinationForPath(
  destinations: PedagogyDestination[],
  path: string,
): PedagogyDestination | undefined {
  return destinations.find((destination) => destination.path === path);
}
